import { render, staticRenderFns } from "./ArticleBlankPage.vue?vue&type=template&id=1d254ef8&scoped=true"
import script from "./ArticleBlankPage.vue?vue&type=script&lang=js"
export * from "./ArticleBlankPage.vue?vue&type=script&lang=js"
import style0 from "./ArticleBlankPage.vue?vue&type=style&index=0&id=1d254ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d254ef8",
  null
  
)

export default component.exports